import { wait } from '@/__mocks__/util/async.ts'
import { status } from '@/__mocks__/config.ts'
import { levelsData } from '@/__mocks__/modules/clientLevels/data.ts'

export const levelsRoutes = [
  {
    method: 'GET',
    path: /\/loyalty\/level\/[^/]+$/,
    reply: async (config: any) => {
      await wait()
      const id = config.url.split('/').pop()
      const level = levelsData.data.results.find((l) => l.id === id)
      return level
        ? [status.ok, level]
        : [status.notFound, { message: 'Nivel no encontrado' }]
    }
  },
  {
    method: 'POST',
    path: '/loyalty/level',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: /\/loyalty\/level\/[^/]+$/,
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: /\/loyalty\/level\/[^/]+$/,
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
